import { FunctionComponent, useState } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useConfig } from '~components/hooks';
import { Post } from '~components/hooks';
import {
  DocumentRenderer,
  DocumentRendererProps,
} from '@keystone-6/document-renderer';
import { Image } from 'antd';
interface Props {
  getPost: Post;
}

import { Swiper, SwiperSlide } from 'swiper-cjs/react';
import SwiperCore, { Navigation, Thumbs } from 'swiper-cjs';

SwiperCore.use([Navigation, Thumbs]);

const Sliders = ({ items, setVisible, privew = false, props }) => (
  <Swiper {...props}>
    {_.map(items, ({ id, image }) => (
      <SwiperSlide key={id}>
        <Image
          preview={!!privew}
          src={`https://keystone.trustunboxing.com${image.url}`}
          onClick={() => privew && setVisible(true)}
        />
      </SwiperSlide>
    ))}
  </Swiper>
);

const componentBlocks: DocumentRendererProps['componentBlocks'] = {
  gallery: ({ items, isSlider }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [visible, setVisible] = useState(false);

    if (isSlider) {
      return (
        <>
          <Image.PreviewGroup
            preview={{ visible, onVisibleChange: vis => setVisible(vis) }}
          >
            <Sliders
              items={items}
              setVisible={setVisible}
              privew={true}
              props={{
                style: {
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff',
                },
                spaceBetween: 10,
                navigation: true,
                thumbs: { swiper: thumbsSwiper },
                className: 'gallery-swiper',
              }}
            />
          </Image.PreviewGroup>

          <Sliders
            items={items}
            setVisible={setVisible}
            props={{
              onSwiper: setThumbsSwiper,
              spaceBetween: 10,
              slidesPerView: 3,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              className: 'gallery-swiper-thumbs',
            }}
          />
        </>
      );
    }

    return (
      <Image.PreviewGroup>
        {_.map(items, ({ id, image }) => (
          <Image
            src={`https://keystone.trustunboxing.com${image.url}`}
            key={id}
          />
        ))}
      </Image.PreviewGroup>
    );
  },
  video: ({ video }) => (
    <iframe width="100%" height="300px" src={video}></iframe>
  ),
};

const renderers: DocumentRendererProps['renderers'] = {
  inline: {
    link: ({ children, href }) => {
      const getConfig = useConfig();

      if (!href.includes(getConfig?.hostname)) {
        return (
          <a href={href} rel="noopener noreferrer nofollow" target="_blank">
            <strong>{children}</strong>
          </a>
        );
      }

      return (
        <Link to={href.replace(`https://${getConfig?.hostname}`, '')}>
          {children}
        </Link>
      );
    },
  },
};

export const PostContent: FunctionComponent<Props> = ({ getPost }) => {
  const content = getPost?.content?.document;

  return (
    <div className="news-single-content">
      <DocumentRenderer
        document={content}
        renderers={renderers}
        componentBlocks={componentBlocks}
      />
    </div>
  );
};
